export default "__VITE_ASSET__C3k1iQ51__"